module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/menuView-actionIconsInline.html -->\n<ul class="nav nav-icons" role="menu">\n	<li role="presentation" class="nx-action" data-action="{{action}}"><a href="{{route}}" class="action" aria-controls="{{label}}" role="tab" data-toggle="tab">{{icon}}</a></li>\n</ul>';
}
return __p;
};
